import React from 'react'

const Pricing = () => {
    const navigateToHome = () => {
        window.location.href = '/';
      }
    
    return (
        <div>
            <section class="text-gray-600 body-font">
                <div class="container px-5 py-24 mx-auto">
                    <div class="flex flex-col text-center w-full mb-20">
                  <p className='text-gray-700 cursor-pointer' onClick={navigateToHome}>Workouts &gt; Price</p>
                        <h1 class="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">Pricing</h1>
                        <p class="lg:w-2/3 mx-auto leading-relaxed text-base">
                            Banh mi cornhole echo park skateboard authentic crucifix neutra tilde lyft biodiesel artisan direct trade mumblecore 3 wolf moon twee
                        </p>
                    </div>
                    <div class="lg:w-2/3 w-full mx-auto overflow-auto">
                        <table class="table-auto w-full text-left whitespace-no-wrap">
                            <thead>
                                <tr>
                                    <th class="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100 rounded-tl rounded-bl">Plan</th>
                                    <th class="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">Workouts</th>
                                    <th class="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">Users</th>
                                    <th class="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">Cost</th>
                                    <th class="w-10 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100 rounded-tr rounded-br"></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">Starter</td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">10</td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">1 </td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3 text-lg text-gray-900">$10</td>
                                    <td class="border-t-2 border-gray-200 w-10 text-center">
                                        <button class="flex ml-auto text-white bg-[#00925D] border-0 py-2 px-6 focus:outline-none hover:bg-[#00925D] rounded">Pay</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">Pro</td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">20 </td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3">2 </td>
                                    <td class="border-t-2 border-gray-200 px-4 py-3 text-lg text-gray-900">$15</td>
                                    <td class="border-t-2 border-gray-200 w-10 text-center">
                                        <button class="flex ml-auto text-white bg-[#00925D] border-0 py-2 px-6 focus:outline-none hover:bg-[#00925D] rounded">Pay</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-t-2 border-b-2 border-gray-200 px-4 py-3">Chef</td>
                                    <td class="border-t-2 border-b-2 border-gray-200 px-4 py-3">Unlimited</td>
                                    <td class="border-t-2 border-b-2 border-gray-200 px-4 py-3">Unlimited</td>
                                    <td class="border-t-2 border-b-2 border-gray-200 px-4 py-3 text-lg text-gray-900">$20</td>
                                    <td class="border-t-2 border-b-2 border-gray-200 w-10 text-center">
                                        <button class="flex ml-auto text-white bg-[#00925D] border-0 py-2 px-6 focus:outline-none hover:bg-[#00925D] rounded">Pay</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div class="flex pl-4 mt-4 lg:w-2/3 w-full mx-auto">

                        <button class="flex ml-auto text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">Button</button>
                    </div> */}
                </div>
            </section>
        </div>
    )
}

export default Pricing